import { render, staticRenderFns } from "./arbitrage.vue?vue&type=template&id=563dd47a"
import script from "./arbitrage.vue?vue&type=script&lang=js"
export * from "./arbitrage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports